import {
  IonButton,
  IonCol,
  IonGrid,
  IonImg,
  IonRow,
  IonToast
} from "@ionic/react";
import {
  clearConfirmStartInformationStatusMessage,
  confirmStartInformationStatusMessage,
  updateStopInformation,
} from "../../../actions/myload/action";
import { Arrival } from "../../../components/app/ShipmentUpdateScreen/arrival";
import { Departure } from "../../../components/app/ShipmentUpdateScreen/departure";
import { ETA } from "../../../components/app/ShipmentUpdateScreen/eta";
import { TrailerIn } from "../../../components/app/ShipmentUpdateScreen/trailerIn";
import { TrailerOut } from "../../../components/app/ShipmentUpdateScreen/trailerOut";
import { StartTripModel } from "../../../models/home/StartTrip.model";
import { UpdateStopModel } from "../../../models/home/updateStop.model";
import {
  defaultStopActivity,
  getStopActivity,
  StopActivityProps,
} from "../../../models/stopActivity.model";
import _ from "lodash";
import {
  EquipmentFlow,
  StopInformation,
} from "../../../schemas/Exicution/exicution.schema";
import { set_depMaxTime, set_depMinTime } from "../../../services/common.services";
import { logEvent, setScreenName } from "../../../utils/Analytics";
import {
  EGPSTrackingStatus,
  EXECUTIONSTATUS,
  EXECUTION_ERRORS,
  MODULES,
  OTHER,
  TRAILER_TYPES,
  FIVE_SEC, 
  ONE_HOUR,
  LATE_REASON_CODE_MODAL_TITLE,
  LATE_REASON_CODE_MODAL_MESSAGE,
  BORDER_CROSSING,
  RELAY,
} from "../../../utils/constants";
import { EVENT, SCREEN } from '../../../utils/constants.analytics';
import { getAppointmentTime, isHardStop } from "../../../utils/formatData";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  deliveredData,
  inTransitData,
  loadAssignedData,
  loadCarrierData,
} from "../../../actions/carrierAssign/action";
import { IONICWrapper } from "../../../utils/common";
import { ToastMessage } from "../../../utils/ToastMessage";
import i18n from "i18n";
import { chassisNumberFinder } from "./executionUtils";
import { dayjs } from "../../../utils/Date/DateUtil";
import { removePropertyFromObject } from "../../utils/BasicLogical.Util";
import { CustomModalWeb } from "../../pages/userProfile/CustomModalWeb";
import { lateReasonOptions } from "../../../utils/mock_Data";
import { SelectComponent } from "../../../components/shared/SelectComponent";
import './TripDetails.scss'
import { lateReasonCodeModalDropDownValues, lateReasonCodeModalVisibility } from "../../../utils/sourceTMSAndDivisionFilter";
import { LoadStopModel } from "../../../components/app/ShipmentUpdateScreen/loadStopUtil";

export const TripDetailsWeb: React.FunctionComponent<any> = (props: any) => {

  const dispatch = useDispatch();
  const [ETA_VALUE, setETA] = useState<string>("");
  const [ARRIVAL_VALUE, setARRIVAL] = useState<string>("");
  const [DEPARTURE_VALUE, setDEPARTURE] = useState<string>("");
  const [TRAILER_IN, setTRAILERIN] = React.useState("");
  const [TRAILER_OUT, setTRAILEROUT] = React.useState("");
  const [
    TRAILER_IN_ACTIVITY,
    setTRAILERINACTIVITY,
  ] = React.useState<StopActivityProps | null>(null);
  const [
    TRAILER_OUT_ACTIVITY,
    setTRAILEROUTACTIVITY,
  ] = React.useState<StopActivityProps | null>(null);
  const [isErrorOnArrival, onArrivalErrorChange] = useState<boolean>(false);
  const [isErrorOnDeparture, onDepartureErrorChange] = useState<boolean>(false);
  const [trailerInError, setTrailerInError] = useState<boolean>(false);
  const [hideToast, setHideToast] = useState<boolean>(true)
  const [OOSTRAILER, setOOSTRAILER] = useState<boolean>(false);
  const [showTrailerInDropDown, setShowTrailerInDropDown] = useState<boolean>(false);
  const [showTrailerOutDropDown, setShowTrailerOutDropDown] = useState<boolean>(false);
  const [lateReasonModalOpen,setLateReasonModalOpen] = useState<boolean>(false);
  const [lateReason,setLateReason] = useState<string | null>(null);
  const startTripModel = new StartTripModel();
  const loadStopModel = new LoadStopModel();
  const stopDetail = props.stopDetails;
  const depMinTime = set_depMinTime();
  const depMaxTime = set_depMaxTime();
  const module = props.history?.loaction?.state?.module;
  const updateStopInformationResponsePayload = useRef<any>(null);

  useEffect(() => {
    const currentDate = new Date(
      startTripModel.getTimeWithTimezone(stopDetail.timeZone)
    );
    currentDate.setMinutes(currentDate.getMinutes() + 60);
    if (ARRIVAL_VALUE && new Date(ARRIVAL_VALUE) > currentDate) {
      onArrivalErrorChange(true);
      setArrivalClass("form-field-error");
    } 
    else {
      onArrivalErrorChange(false);
      if (ARRIVAL_VALUE) {
        setArrivalClass("form-field-success");
      }
    }
  }, [ARRIVAL_VALUE]);

  useEffect(() => {
    const currentDate = new Date(
      startTripModel.getTimeWithTimezone(stopDetail.timeZone)
    );
    currentDate.setMinutes(currentDate.getMinutes() + depMaxTime);

    if (DEPARTURE_VALUE) {
      const _arrival = ARRIVAL_VALUE ? new Date(ARRIVAL_VALUE) : currentDate;
      const _departure = new Date(DEPARTURE_VALUE);
      let isError = false;
      if (_departure > currentDate) {
        isError = true;
      }
      _arrival.setMinutes(_arrival.getMinutes() + depMinTime);
      if (!isError && _arrival > _departure) {
        isError = true;
      }
      if (isError) {
        onDepartureErrorChange(true);
        setDepartureClass("form-field-error");
      } else {
        onDepartureErrorChange(false);
        if (DEPARTURE_VALUE) {
          setDepartureClass("form-field-success");
        }
      }
    } else {
      onDepartureErrorChange(false);
      if (DEPARTURE_VALUE) {
        setDepartureClass("form-field-success");
      }
    }
  }, [DEPARTURE_VALUE]);

  const getTrailerInValue = (): StopActivityProps => {
    if (!TRAILER_IN_ACTIVITY) {
      return { ...defaultStopActivity, stopId: stopDetail.stopId };
    }

    return {
      equipmentFlow: EquipmentFlow.TRAILER_IN,
      equipmentId: TRAILER_IN.includes(OTHER) ? TRAILER_IN.slice(5) : TRAILER_IN,
      equipmentOwner: TRAILER_IN_ACTIVITY.equipmentOwner,
      equipmentType: TRAILER_IN_ACTIVITY.equipmentType,
      id: TRAILER_IN_ACTIVITY.id,
      name: TRAILER_IN_ACTIVITY.name,
      stopId: TRAILER_IN_ACTIVITY.stopId,
      execActivity: TRAILER_IN_ACTIVITY.execActivity,
      seqNo: TRAILER_IN_ACTIVITY.seqNo,
      tmsActivity: TRAILER_IN_ACTIVITY.tmsActivity,
    };
  };

  const getTrailerOutValue = (): StopActivityProps => {
    if (!TRAILER_OUT_ACTIVITY) {
      return { ...defaultStopActivity, stopId: stopDetail.stopId };
    }

    return {
      equipmentFlow: EquipmentFlow.TRAILER_OUT,
      equipmentId: TRAILER_OUT.includes(OTHER) ? TRAILER_OUT.slice(5) : TRAILER_OUT,
      equipmentOwner: TRAILER_OUT_ACTIVITY.equipmentType,
      id: TRAILER_OUT_ACTIVITY.id,
      name: TRAILER_OUT_ACTIVITY.name,
      stopId: TRAILER_OUT_ACTIVITY.stopId,
      equipmentType: TRAILER_OUT_ACTIVITY.equipmentType,
      execActivity: TRAILER_OUT_ACTIVITY.execActivity,
      seqNo: TRAILER_OUT_ACTIVITY.seqNo,
      tmsActivity: TRAILER_OUT_ACTIVITY.tmsActivity,
    };
  };

  const isManagedEquipment = props.shipmentToStartTrip && props.shipmentToStartTrip.managedEquipment || false;
  const lateReasonCodeModalProps = {
    isModalOpen:  lateReasonModalOpen,
    title: LATE_REASON_CODE_MODAL_TITLE,
    message :LATE_REASON_CODE_MODAL_MESSAGE,
    contentAlignment: "left",
    aditionalCssClass : "late-reason-code-modal",
    size: "medium",
    contentScroll: "deny",
    backdropDismiss:false,
    buttons: [
      {
        title: i18n.t('Save'),
        type: "primary-cta-btn-mobile",
        isDisabled : (lateReason === "" || lateReason === null || lateReason === undefined) ? true :false,
        onClick: () => {
          setLateReasonModalOpen(false)
          logEvent(EVENT.UE_LATE_REASON_CODE_SUBMIT, {
            screen : SCREEN.LATE_REASON_CODE_MODAL,
            shipmentId: props?.loadDetails?.shipmentId,
            stopID: stopDetail.stopId,
            lateReasonCode : lateReason
          });
       }
  }
    ]
  };
  const handleLateReasonChange = ({ name, value }: any) =>
  {
    setLateReason(value.key)
  }
 const updateStopInfo = (trailerWarning?:boolean) => {
    const networkTrailerInData = props?.stopDetails?.stopActivity?.find((item:any)=>item?.execActivity ==="TRAILER_IN")?.equipmentId;
    const networkTrailerOutData = props?.stopDetails?.stopActivity?.find((item:any)=>item?.execActivity ==="TRAILER_OUT")?.equipmentId;
    startTripModel.removeGetInvalidTrailer();
    if (!isManagedEquipment) {
      if (props.optionSelected === '') {
        props.setoptionSelectedErrorMsg(true);
        ToastMessage.show(i18n.t('COMPLETE_REQUIRED_FIELDS'));
        return;
      }

      if (ARRIVAL_VALUE && props.optionSelected === 'yes' && (TRAILER_IN === "" || TRAILER_IN === TRAILER_TYPES.TA || TRAILER_IN === TRAILER_TYPES.SNLU || TRAILER_IN === TRAILER_TYPES.OTHER)) {
        ToastMessage.show(EXECUTION_ERRORS.VALID_TRAILER_IN);
        return;
      }

      if (DEPARTURE_VALUE && props.optionSelected === 'yes' && (TRAILER_IN === "" || TRAILER_IN === TRAILER_TYPES.TA || TRAILER_IN === TRAILER_TYPES.SNLU || TRAILER_IN === TRAILER_TYPES.OTHER)) {
        ToastMessage.show(EXECUTION_ERRORS.VALID_TRAILER_IN);
        return;
      }
      if (DEPARTURE_VALUE && props.optionSelected === 'yes' && (TRAILER_OUT === "" || TRAILER_OUT === TRAILER_TYPES.TA || TRAILER_OUT === TRAILER_TYPES.SNLU || TRAILER_OUT === TRAILER_TYPES.SNCZ || TRAILER_OUT === TRAILER_TYPES.OTHER)) {
        ToastMessage.show(EXECUTION_ERRORS.VALID_TRAILER_OUT);
        return;
      }
    }

    if (TRAILER_IN !== "" && ((!networkTrailerInData && !ARRIVAL_VALUE) || 
    (!!networkTrailerInData && networkTrailerInData?.toUpperCase() !== TRAILER_IN?.toUpperCase() && !ARRIVAL_VALUE))) {
      onArrivalErrorChange(true);
      ToastMessage.show(i18n.t('COMPLETE_REQUIRED_FIELDS'));
      return;
    }
    if (TRAILER_OUT !== "" && ((!networkTrailerOutData && !DEPARTURE_VALUE) || 
    (!!networkTrailerOutData && networkTrailerOutData?.toUpperCase() !== TRAILER_OUT?.toUpperCase() && !DEPARTURE_VALUE))){
      onDepartureErrorChange(true);
      if (!TRAILER_IN) setTrailerInError(true);
      ToastMessage.show(i18n.t('COMPLETE_REQUIRED_FIELDS'));
      return;
    }

    setHideToast(true)
    IONICWrapper.details.setValue = { 'index': props.index };
    if (!startTripModel.hasInvalidTrailer(props.loadDetails, stopDetail)) {
      dispatch(
        confirmStartInformationStatusMessage({
          status: false,
          message: EXECUTION_ERRORS.INVALID_TRAILER_OUT_WARNING.replace("#", StartTripModel.getInvalidTrailer),
        })
      );
      return;
    }
    setShowTrailerInDropDown(false);
    setShowTrailerOutDropDown(false);
    const currentDate = new Date(
      startTripModel.getTimeWithTimezone(stopDetail.timeZone)
    );
    currentDate.setMinutes(currentDate.getMinutes() + depMaxTime);
    const isDepartureReadonly = startTripModel.isDepartureReadonly(
      stopDetail,
      ARRIVAL_VALUE
    );
    if (ARRIVAL_VALUE) {
      const _isArrivalReadonly = startTripModel.isArrivalReadonly(stopDetail);
      if (new Date(ARRIVAL_VALUE) > currentDate && !_isArrivalReadonly) {
        dispatch(
          confirmStartInformationStatusMessage({
            status: false,
            message: EXECUTION_ERRORS.ARRIVAL_ERROR,
          })
        );
        onArrivalErrorChange(true);
        return logEvent(EVENT.UE_STOP_UPDATE_FAILURE, {
          carrierId: props.carrierId,
          shipmentId: props?.loadDetails?.shipmentId,
          stopID: stopDetail.stopId,
          lateReasonCode : lateReason
        });
      }
      if (
        !startTripModel.isOTypeStop(props.stopDetails) &&
        !TRAILER_IN &&
        startTripModel.isManagedEquipmentWithTrailerValidation(TRAILER_IN, props.loadDetails)
      ) {
        dispatch(
          confirmStartInformationStatusMessage({
            status: false,
            message: EXECUTION_ERRORS.TRAILER_IN_ERROR,
          })
        );
        return;
      }
    }

    if (DEPARTURE_VALUE) {
      const _arrival = ARRIVAL_VALUE ? new Date(ARRIVAL_VALUE) : currentDate;
      const _departure = new Date(DEPARTURE_VALUE);
      if (_departure > currentDate && !isDepartureReadonly) {
        dispatch(
          confirmStartInformationStatusMessage({
            status: false,
            message: EXECUTION_ERRORS.DEPARTURE_ERROR,
          })
        );
        onDepartureErrorChange(true);
        return;
      }
      _arrival.setMinutes(_arrival.getMinutes() + depMinTime);
      if (_arrival > _departure && !isDepartureReadonly) {
        dispatch(
          confirmStartInformationStatusMessage({
            status: false,
            message: EXECUTION_ERRORS.DEPARTURE_ARRIVAL_ERROR,
          })
        );
        onDepartureErrorChange(true);
        return;
      }
      if (
        !startTripModel.isOTypeStop(props.stopDetails) &&
        !TRAILER_IN &&
        startTripModel.isManagedEquipmentWithTrailerValidation(TRAILER_IN, props.loadDetails)
      ) {
        dispatch(
          confirmStartInformationStatusMessage({
            status: false,
            message: EXECUTION_ERRORS.TRAILER_IN_ERROR,
          })
        );
        return;
      }
      if (
        !startTripModel.isOTypeStop(props.stopDetails) &&
        !TRAILER_OUT &&
        startTripModel.isManagedEquipmentWithTrailerValidation(TRAILER_OUT, props.loadDetails)
      ) {
        dispatch(
          confirmStartInformationStatusMessage({
            status: false,
            message: EXECUTION_ERRORS.TRAILER_OUT_ERROR,
          })
        );
        return;
      }
    }

    if (
      TRAILER_OUT &&
      startTripModel.isManagedEquipmentWithTrailerValidation(TRAILER_OUT, props.loadDetails)
    ) {
      dispatch(
        confirmStartInformationStatusMessage({
          status: false,
          message: EXECUTION_ERRORS.VALID_TRAILER_OUT,
        })
      );
      return;
    }
    if (
      TRAILER_IN &&
      startTripModel.isManagedEquipmentWithTrailerValidation(TRAILER_IN, props.loadDetails)
    ) {
      dispatch(
        confirmStartInformationStatusMessage({
          status: false,
          message: EXECUTION_ERRORS.VALID_TRAILER_IN,
        })
      );
      return;
    }

    let trailerIn: StopActivityProps;
    let trailerOut: StopActivityProps;
    const activity: StopActivityProps[] = [];
    trailerIn = getTrailerInValue();
    trailerOut = getTrailerOutValue();
    if (trailerIn.equipmentFlow === EquipmentFlow.TRAILER_IN) {
      activity.push(trailerIn);
    }

    if (trailerOut.equipmentFlow === EquipmentFlow.TRAILER_OUT) {
      activity.push(trailerOut);
    }

    const stopInfo: StopInformation = {
      carrierPro: "",
      carrierScac: "",
      stopId: stopDetail.stopId,
      sequenceNo: stopDetail.sequenceNo,
      stopNumber: stopDetail.sequenceNo,
      locationId: stopDetail.locationId,
      city: stopDetail.city,
      state: stopDetail.state,
      country: stopDetail.country,
      latitude: stopDetail.latitude && parseFloat(stopDetail.latitude),
      longitude: stopDetail.longitude && parseFloat(stopDetail.longitude),
      gpsTrackingStatus: props?.loadDetails?.gpsTrackingStatus ? props?.loadDetails?.gpsTrackingStatus : EGPSTrackingStatus.GPS_TRACKING_NOT_STARTED,
      timeZone: stopDetail.timeZone,
      positionDateTime: new Date().toISOString(),
      actualArrivalDateTime: ARRIVAL_VALUE,
      actualETADateTime: ETA_VALUE,
      actualDepartureDateTime: DEPARTURE_VALUE,
      stopTrailerActivity: activity,
      carrierId: "",
      shipmentId: stopDetail.shipmentId,
      sourceSystem: stopDetail.sourceSystem,
      userId: "",
      lateArrivalReason:lateReason
    };
    stopInfo.shipmentId = props.shipmentId;
    stopInfo.sourceSystem = props.loadDetails.sourceTMS;
    const _model: UpdateStopModel = new UpdateStopModel();
    const { userDetails = {} } = props;

    const callBack = async (
      shipment: any,
      status: boolean,
      message: string
    ) => {
      refreshShipmentsLoads(shipment);
      const currentOpenStopSNo = props.expandedStop + 1;
      const payload = {
        shipmentId: stopInfo.shipmentId,
        sequenceNo: stopInfo.sequenceNo
      };
      const isWarningDialogStatusAndMessage: boolean = status && !!message;
      if (!isWarningDialogStatusAndMessage) {
        if (currentOpenStopSNo === stopInfo.sequenceNo) {
          props.updateStopInformationResponse(payload);
        } else {
          props.clearUpdateStopInformationResponse();
        }
      } else {
        updateStopInformationResponsePayload.current = payload;
      }
    };
    let stopTrailerActivity: any = stopInfo.stopTrailerActivity;
    stopTrailerActivity = stopTrailerActivity.map((obj: any) => removePropertyFromObject(obj, "chassisNumber"));
    let updateStopPayload: StopInformation = {
      sourceSystem: stopInfo.sourceSystem,
      carrierPro: stopInfo.carrierPro,
      carrierScac: stopInfo.carrierScac,
      shipmentId: stopInfo.shipmentId,
      stopId: stopInfo.stopId,
      sequenceNo: stopInfo.sequenceNo,
      stopNumber: stopInfo.stopNumber,
      locationId: stopInfo.locationId,
      carrierId: userDetails && userDetails.memberDetailsResponse &&
        userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
      userId: userDetails && userDetails.memberDetailsResponse &&
        userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.upn,
      city: stopInfo.city,
      state: stopInfo.state,
      country: stopInfo.country,
      latitude: stopInfo.latitude,
      longitude: stopInfo.longitude,
      gpsTrackingStatus: props?.loadDetails?.gpsTrackingStatus ? props?.loadDetails?.gpsTrackingStatus : EGPSTrackingStatus.GPS_TRACKING_NOT_STARTED,
      timeZone: stopInfo.timeZone,
      positionDateTime: stopInfo.positionDateTime,
      actualArrivalDateTime: getTime(
        stopInfo.actualArrivalDateTime,
        stopInfo.timeZone
      ),
      actualETADateTime: getTime(
        stopInfo.actualETADateTime,
        stopInfo.timeZone
      ),
      actualDepartureDateTime: getTime(
        stopInfo.actualDepartureDateTime,
        stopInfo.timeZone
      ),
      stopTrailerActivity: stopTrailerActivity,
      lateArrivalReason:lateReason
    }
    if (!isManagedEquipment) {
      if (props.optionSelected === 'yes') {
        updateStopPayload = { ...updateStopPayload, schneiderEquipment: true }
      }
      else if (props.optionSelected === 'no') {
        updateStopPayload = { ...updateStopPayload, schneiderEquipment: false }

      }
    }
if (trailerWarning)
  updateStopPayload = {
    ...updateStopPayload,
    userConcentForTrailerWarning: trailerWarning,
  };

    dispatch(
      updateStopInformation(
        _model.updateStop({ ...updateStopPayload }),
        callBack
      )
    );
  };

  const getConfirmStartStatus = () => {
    const response = props.startTripShipmentStatusMessage || {};

    return response.status === false;
  };

  const getConfirmStartMessage = () => {
    const response = props.startTripShipmentStatusMessage || {};
    return response.message;
  };

  const getTime = (time: string, timeZone: string): string => {
      return time ? dayjs.tz(time.slice(0, 16).replace("T"," "), timeZone).format(): time;
  };

  const refreshShipmentsLoads = (shipment: any) => {
    if (shipment.executionStatus === EXECUTIONSTATUS.IN_TRANSIT) {
      removeLoadsFromDriverToIntransit(shipment);
    } else if (shipment.executionStatus === EXECUTIONSTATUS.DELIVERED) {
      removeLoadsFromIntransitToDelivered(shipment);
    }
    // Analytics implementation
    setScreenName("screen_update_stop");
    logEvent(EVENT.UE_STOP_UPDATE_SUCCESS, {
      carrierId: props.carrierId,
      shipmentId: props?.loadDetails?.shipmentId,
      stopID: stopDetail.stopId,
      lateReasonCode : lateReason
    });
  };

  const removeLoadsFromDriverToIntransit = (shipment: any) => {
    const shipmentId: string = shipment && shipment.shipmentId;
    if (!shipmentId) {
      return;
    }

    const driverAssignedload: boolean = module === MODULES.DRIVER_ASSIGNED_MODULE;
    const loads = driverAssignedload ? props.driverLoads : props.carrierLoads;
    const LoadList: any[] = loads.filter(
      (item: any) => item.shipmentId !== shipmentId
    );

    const isExists =
      loads.filter((item: any) => item.shipmentId === shipmentId)
        .length > 0;

    if (isExists) {
      let inTransitLoads: any[] = props.inTransitLoads || [];
      if (shipment) {
        inTransitLoads = inTransitLoads.concat({ ...shipment });
      }
      driverAssignedload ? dispatch(loadAssignedData(LoadList, LoadList.length)) : dispatch(loadCarrierData(LoadList, LoadList.length));

      dispatch(inTransitData(inTransitLoads, inTransitLoads.length));
    }
  };

  const removeLoadsFromIntransitToDelivered = (shipment: any) => {
    const shipmentId: string = shipment && shipment.shipmentId;
    if (!shipmentId) {
      return;
    }

    const inTransitLoads: any[] = props.inTransitLoads.filter(
      (item: any) => item.shipmentId !== shipmentId
    );
    const driverLoads: any[] = props.driverLoads.filter(
      (item: any) => item.shipmentId !== shipmentId
    );

    const isExists =
      props.inTransitLoads.filter((item: any) => item.shipmentId === shipmentId)
        .length > 0;

    const isDriverload =
      props.driverLoads.filter((item: any) => item.shipmentId === shipmentId)
        .length > 0;

    if (isDriverload) {
      dispatch(loadAssignedData(driverLoads, driverLoads.length));
    }
    if (isExists) {
      dispatch(inTransitData(inTransitLoads, inTransitLoads.length));
    }
    let recentDelivered: any[] = props.recentDelivered || [];
    if (shipment) {
      recentDelivered = recentDelivered.concat({ ...shipment });
      dispatch(deliveredData(recentDelivered, recentDelivered.length));
    }
  };
  const calculateTime = (stop: any) => {
    const timeUpdated = getAppointmentTime(stop).split('AM').join('am').split('PM').join('pm');
    return timeUpdated;

  };

  const [etaClass, setEtaClass] = useState<string>("form-field-default");
  const [arrivalClass, setArrivalClass] = useState<string>(
    "form-field-default"
  );
  const [departureClass, setDepartureClass] = useState<string>(
    "form-field-default"
  );
  const [trailerInClass, setTrailerInClass] = useState<string>(
    "form-field-default"
  );
  const [trailerOutClass, setTrailerOutClass] = useState<string>(
    "form-field-default"
  );

  /**
    * To hide the TrailerIn dropdown when TrailerOut dropdown is opened on web.
    * @param {isShow} it checks for wheather TrailerOut modal needs to shown or not
    * 
    */
  const handleShowTrailerInDropDown = (isShow: boolean) => {
    if (showTrailerOutDropDown) {
      setShowTrailerOutDropDown(false);
    }
    setShowTrailerInDropDown(isShow);
  }
  /**
  * To hide the TrailerOut dropdown when TrailerIn dropdown is opened on web.
  * @param {isShow} it checks for wheather TrailerIn modal needs to shown or not
  * 
  */
  const handleShowTrailerOutDropDown = (isShow: boolean) => {
    if (showTrailerInDropDown) {
      setShowTrailerInDropDown(false);
    }
    setShowTrailerOutDropDown(isShow);
  }

  useEffect(() => {
    if (!ETA_VALUE && etaClass != "form-field-error") {
      setEtaClass("form-field-default");
    } else if (!ETA_VALUE) {
      setEtaClass("form-field-success");
    }
  }, [ETA_VALUE]);

  useEffect(() => {
    if (!TRAILER_IN && trailerInClass != "form-field-error") {
      setTrailerInClass("form-field-default");
    } else if (!TRAILER_IN) {
      setTrailerInClass("form-field-success");
    }
  }, [TRAILER_IN]);

  useEffect(() => {
    if (!TRAILER_OUT && trailerOutClass != "form-field-error") {
      setTrailerOutClass("form-field-default");
    } else if (!TRAILER_OUT) {
      setTrailerOutClass("form-field-success");
    }
  }, [TRAILER_OUT]);

  useEffect(() => {
    if (isHardStop(props.startTripShipmentStatusMessage.message) && !props.startTripShipmentStatusMessage.status) setOOSTRAILER(true)
    else IONICWrapper.details.setValue = {};
  }, [props.startTripShipmentStatusMessage.message])

  const warningDialogYesClickHandler = () => {
    props.clearWarningDialogMessage();
      updateStopInfo(true)
  };

  const warningDialogNoClickHandler = () => {
    props.clearWarningDialogMessage();
    updateStopInformationResponsePayload.current = null;
    setTRAILEROUT((prevValue: string) => {
       return prevValue || "";
    });
    props.clearUpdateStopInformationResponse();
  };
  const onOpenLateReasonModal = (value: any) => {
    const diff = dayjs.duration(dayjs(value).diff(dayjs(ETA_VALUE?ETA_VALUE:loadStopModel.getPlannedArrivalTime(stopDetail))));
    const diffFormattedinHours = diff.format("HH");
    const diffFormattedinMinutes = diff.format("mm");
    const currentDate = new Date(
      startTripModel.getTimeWithTimezone(stopDetail.timeZone)
    );
    currentDate.setMinutes(currentDate.getMinutes() + 60);
    setLateReason(null);
    if (new Date(value) < currentDate) {
        if (
        lateReasonCodeModalVisibility(
          props?.loadDetails?.sourceTMS,
          props?.loadDetails?.division,
          diffFormattedinMinutes,
          diffFormattedinHours
        )
      ) {
        setLateReasonModalOpen(true);
        logEvent(EVENT.SV_LATE_REASON_CODE, {
          screen : SCREEN.LATE_REASON_CODE_MODAL,
          shipmentId: props?.loadDetails?.shipmentId,
          stopID: stopDetail?.stopId,
        });
      }
    }
  };

  const modalWarningProps = {
    isModalOpen:  !!props.warningDialogMessage &&
    props.index === parseInt(IONICWrapper.details.getValue.index),
    title: "Update Stop Error",
    message : props.warningDialogMessage,
    contentAlignment: "left",
    aditionalCssClass : "shipment-dialog",
    size: "small_height",
    contentScroll: "deny",
    backdropDismiss:false,
    buttons: [
      {
        title: i18n.t('Yes'),
        type: "secondary-cta-btn-web",
        onClick: () => {      
          warningDialogYesClickHandler()
        }
      },
      {
        title: i18n.t('No'),
        type: "primary-cta-btn-web",
        onClick: () => {
          warningDialogNoClickHandler()
       }
  }
    ]
  
  };
  return (
    <React.Fragment>
      <CustomModalWeb {...modalWarningProps} />
      <CustomModalWeb {...lateReasonCodeModalProps}>
        <div className="late-reason-code">
          <SelectComponent
            key={`lateReason`}
            options={lateReasonCodeModalDropDownValues(props?.loadDetails?.sourceTMS,props?.loadDetails?.division) || lateReasonOptions}
            placeholder={i18n.t("Select Your Reason")}
            label={""}
            name={"lateReason"}
            value={lateReason}
            handleChange={handleLateReasonChange}
          />
        </div>
      </CustomModalWeb>
      <IonToast
        isOpen={hideToast ? getConfirmStartStatus() : false}
        message={_.unescape(getConfirmStartMessage())}
        duration={
          isHardStop(props.startTripShipmentStatusMessage.message)
            ? ONE_HOUR
            : FIVE_SEC
        }
        color="dark"
        onDidDismiss={() => {
          dispatch(clearConfirmStartInformationStatusMessage());
        }}
        onWillPresent={(obj: any) => {
          const toast = obj.target || obj.srcElement;
          const elePhone = toast.shadowRoot.querySelector(
            ".toast-message a.hard-stop-message"
          );
          elePhone &&
            elePhone.setAttribute("style", "color: white;cursor:pointer");
        }}
      />
      <IonGrid className="trip-grid form-field-details">
        <IonRow>
          <IonCol size="6">
            <p className="origin_milehead load_header_elements stop-activity">
              {getStopActivity(
                (stopDetail && stopDetail.stopActivity) ||
                  (stopDetail && stopDetail.specialServices) ||
                  [],
                !props.isCarrierLoad,
                stopDetail.stopType
              )}
            </p>
            <p className="origin_dateTime load_header_elements stop-appointment">
              {calculateTime(stopDetail)}
            </p>
          </IonCol>
          <IonCol size="6" className={`form-field-col ${etaClass}`}>
            <ETA
              timestamp={props.timestamp}
              shipmentId={props.shipmentId}
              loadStop={props.stopDetails}
              onChange={(value: string) => {
                setETA(startTripModel.getRoundOffTime(value));
              }}
              value={ETA_VALUE}
              isNextStop={props.index > props.expandedStop}
              isExpanded={false}
              timeZone={props.stopDetails.timeZone}
              isWeb={true}
            />
            <IonImg
              className="form-field-icon"
              src="assets/icon/ok-pointer.svg"
            />
          </IonCol>
        </IonRow>

        <IonRow>
          <IonCol size="6" className={`form-field-col ${arrivalClass}`}>
            <Arrival
              timestamp={props.timestamp}
              isError={isErrorOnArrival}
              loadStop={props.stopDetails}
              etaValue={ETA_VALUE}
              onChange={(value: string) => {
                setARRIVAL(startTripModel.getRoundOffTime(value));
                new Date(value)>new Date(ETA_VALUE?ETA_VALUE:loadStopModel.getPlannedArrivalTime(stopDetail))
                && (stopDetail?.stopType === "P" || stopDetail?.stopType === "D" || stopDetail?.stopType === BORDER_CROSSING || stopDetail?.stopType === RELAY ) ? setLateReason(lateReason) :setLateReason(null)
              }}
              onBlur ={(value: string) => 
                 new Date(value)>new Date(ETA_VALUE?ETA_VALUE:loadStopModel.getPlannedArrivalTime(stopDetail))
                 && (stopDetail?.stopType === "P" || stopDetail?.stopType === "D" || stopDetail?.stopType === BORDER_CROSSING || stopDetail?.stopType === RELAY ) && onOpenLateReasonModal(value)
              }
              value={ARRIVAL_VALUE}
              isNextStop={props.index > props.expandedStop}
              valueEntered={() => {
                props.arivalEntered(props.index);
              }}
              isExpanded={false}
              timeZone={props.stopDetails.timeZone}
              shipmentId={props.shipmentId}
              isWeb={true}
            />
            <IonImg
              className="form-field-icon"
              src="assets/icon/ok-pointer.svg"
            />
          </IonCol>
          <IonCol size="6" className={`form-field-col ${trailerInClass}`}>
            <TrailerIn
              web
              timestamp={props.timestamp}
              shipment={props.loadDetails}
              expandCurrentStopForcefully={() => {}}
              loadStop={props.stopDetails}
              onChange={(value: string) => {
                setTRAILERIN(value);
                trailerInError && setTrailerInError(false);
              }}
              showDropDown={showTrailerInDropDown}
              handleShowDropDown={(value: boolean) =>
                handleShowTrailerInDropDown(value)
              }
              value={TRAILER_IN}
              isNextStop={props.index > props.expandedStop}
              isExpanded={false}
              shipmentId={props.shipmentId}
              readonly={
                startTripModel.isOTypeStop(props.stopDetails) ||
                startTripModel.isShipmentTripCompleted(props.loadDetails) ||
                startTripModel.areStopActivitiesMissing(props.stopDetails)
              }
              changeActivity={(activity: StopActivityProps) => {
                setTRAILERINACTIVITY(activity);
              }}
              showError={trailerInError || startTripModel.showTrailerInError(
                TRAILER_IN,
                props.loadDetails,
                ARRIVAL_VALUE,
                props.index > props.expandedStop,
                props.stopDetails,
                props.optionSelected === 'yes'
              )}
              updateStopInfo={props.updateStopInfo}
            />
          </IonCol>
        </IonRow>
        {chassisNumberFinder(props.stopDetails.stopActivity,"TRAILER_IN") && 
        <IonRow>
          <IonCol size="6" offsetMd="6" className="chassis-info-container">
            <div className="chassis-label">Chassis :</div>
            <div>{chassisNumberFinder(props.stopDetails.stopActivity,"TRAILER_IN")}</div>
          </IonCol>
        </IonRow>
        }
        <IonRow>
          <IonCol size="6" className={`form-field-col ${departureClass}`}>
            <Departure
              timestamp={props.timestamp}
              isError={isErrorOnDeparture}
              loadStop={props.stopDetails}
              onChange={(value: string) => {
                setDEPARTURE(startTripModel.getRoundOffTime(value));
                isErrorOnDeparture && onDepartureErrorChange(false);
                lateReason === null ? setLateReason(null) : setLateReason(lateReason);
              }}
              value={DEPARTURE_VALUE}
              isNextStop={props.index > props.expandedStop}
              arrivalVal={ARRIVAL_VALUE}
              isExpanded={false}
              timeZone={props.stopDetails.timeZone}
              shipmentId={props.shipmentId}
              isWeb={true}
            />
            <IonImg
              className="form-field-icon"
              src="assets/icon/ok-pointer.svg"
            />
          </IonCol>
          <IonCol size="6" className={`form-field-col ${trailerOutClass}`}>
            <TrailerOut
              web
              shipment={props.loadDetails}
              timestamp={props.timestamp}
              showDropDown={showTrailerOutDropDown}
              handleShowDropDown={(value: boolean) =>
                handleShowTrailerOutDropDown(value)
              }
              expandCurrentStopForcefully={(obj: any) => {
                const index = IONICWrapper.details.getValue.index;
                if (props.index == index && OOSTRAILER) {
                  setHideToast(false);
                  IONICWrapper.details.setValue = {};
                  setOOSTRAILER(false);
                }
                return false;
              }}
              loadStop={props.stopDetails}
              onChange={(value: string) => {
                setTRAILEROUT(value);
                const index = IONICWrapper.details.getValue.index;
                if (props.index == index && OOSTRAILER && value && value !== "TA") {
                  setHideToast(false);
                  IONICWrapper.details.setValue = {};
                  setOOSTRAILER(false);
                }
              }}
              shipmentId={props.shipmentId}
              readonly={
                startTripModel.isShipmentTripCompleted(props.loadDetails) ||
                startTripModel.isOTypeStop(props.stopDetails) ||
                startTripModel.areStopActivitiesMissing(props.stopDetails)
              }
              value={TRAILER_OUT}
              isNextStop={props.index > props.expandedStop}
              isExpanded={false}
              changeActivity={(activity: StopActivityProps) => {
                setTRAILEROUTACTIVITY(activity);
              }}
              showError={startTripModel.showTrailerOutError(
                TRAILER_OUT,
                props.loadDetails,
                DEPARTURE_VALUE,
                props.index > props.expandedStop,
                props.stopDetails,
                props.optionSelected === 'yes'
              )}
            />
          </IonCol>
        </IonRow>
        {chassisNumberFinder(props.stopDetails.stopActivity,"TRAILER_OUT") && 
        <IonRow>
          <IonCol size="6" offsetMd="6" className="chassis-info-container">
            <div className="chassis-label">Chassis :</div>
            <div>{chassisNumberFinder(props.stopDetails.stopActivity,"TRAILER_OUT")}</div>
          </IonCol>
        </IonRow>
        }
        {!startTripModel.isTripCompleted(props.loadDetails) && (
          <IonRow>
            <IonCol size="12" className="ion-no-padding">
              <IonButton
                className="update-stop-info"
                disabled={
                  props.index > props.expandedStop ||
                  startTripModel.isShipmentTripCompleted(props.loadDetails)
                }
                onClick= {() => updateStopInfo()}
                expand="full"
              >
                Update Stop Information
              </IonButton>
            </IonCol>
          </IonRow>
        )}
      </IonGrid>
    </React.Fragment>
  );
};
